import unique from 'array-unique';

function loadImg(url) {
  return new Promise(function(resolve, reject) {
    var img = new Image();
    img.src = url;
    img.addEventListener('load', resolve);
  });
}

function loadImgs(...imgs) {
  return Promise.all(unique(imgs).map(loadImg));
}

loadImgs.assoc = function(imgs) {
  let result = {};
  let proms = [];
  for (let i in imgs) {
    let prom = new Promise(function(resolve, reject) {
      var img = new Image();
      img.src = imgs[i];
      result[i] = img;
      img.addEventListener('load', resolve);
    });
    proms.push(prom);
  }

  return new Promise((resolve, reject) => {
    Promise.all(proms).then(_ => resolve(result));
  });
};

export default loadImgs;
